
import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '@/components/utils/PageWrapper';
import AnimatedElement from '@/components/utils/AnimatedElement';
import { motion } from 'framer-motion';

const NotFound = () => {
  return (
    <PageWrapper>
      <div className="flex-grow flex items-center justify-center py-20">
        <motion.div
          whileHover={{ scale: 1.03 }}
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
          className="service-card w-full max-w-lg mx-auto"
        >
          <AnimatedElement animation="scale" className="glass-card p-12 text-center">
            <motion.h1 
              className="text-5xl font-bold mb-4 text-primary"
              initial={{ scale: 1 }}
              animate={{ scale: [1, 1.05, 1] }}
              transition={{ 
                duration: 2,
                repeat: Infinity,
                repeatType: "reverse"
              }}
            >
              404
            </motion.h1>
            <AnimatedElement animation="fadeIn" delay={0.2}>
              <h2 className="text-2xl font-semibold mb-6">Page Not Found</h2>
            </AnimatedElement>
            <AnimatedElement animation="fadeIn" delay={0.4}>
              <p className="text-muted-foreground mb-8">
                The page you're looking for doesn't exist or has been moved.
              </p>
            </AnimatedElement>
            <AnimatedElement animation="slideUp" delay={0.6}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link
                  to="/"
                  className="glass-button-primary px-6 py-3 text-base font-medium inline-block btn-hover-glow"
                >
                  Return to Home
                </Link>
              </motion.div>
            </AnimatedElement>
          </AnimatedElement>
        </motion.div>
      </div>
    </PageWrapper>
  );
};

export default NotFound;
